export type Theme = "light" | "dark";

const KEY = "sautria:theme";
const BRAND = { light: "#1F5EEA", dark: "#0B1220" };

export function storedTheme(): Theme {
  try {
    return localStorage.getItem(KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

/** The design system reads data-theme and data-family on <html> (Asklepios is the sautria family). */
function apply(theme: Theme) {
  document.documentElement.dataset.theme = theme;
  document.documentElement.dataset.family = "asklepios";
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", BRAND[theme]);
}

/** Light is the product default; the system setting is not followed unless the person chooses dark. */
export function setTheme(theme: Theme) {
  apply(theme);
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* private mode: the choice lasts for this page only */
  }
}

export function applyStoredTheme() {
  apply(storedTheme());
}
